module.exports = __webpack_public_path__ + "static/media/tra_spe_con_con.940ebfda.png";